(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playably-games-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Relabel the hero secondary button "See a live game" -> "Play Live Game" (frozen-page safe).
  function relabelLiveGame() {
    var b = document.querySelector('.pa-games-art .pa-gh-actions .pa-btn.ghost');
    if (b && b.textContent.trim() !== 'Play Live Game') { b.textContent = 'Play Live Game'; }
    // safety net only: repoint any stray "#" "case study" link to the real slug
    document.querySelectorAll('.cs-other a[href="#"], a[href="#"]').forEach(function (a) {
      var t = (a.textContent || '').toLowerCase();
      if (t.indexOf('case study') > -1 || t.indexOf('case studies') > -1) { a.setAttribute('href', '/pages/case-studies'); }
    });
    /* NOTE: the games page is NOT a frozen cache anymore (rebuilt to real theme sections,
       template 20141633863722 / page.games.json). Button label, brand-crawl position, and
       copy are now driven by the template directly, so the old DOM-injection hacks were
       removed. Edit page.games.json / the section settings normally. */
  }
  if (document.readyState !== 'loading') { relabelLiveGame(); }
  document.addEventListener('DOMContentLoaded', relabelLiveGame);
})();
(function () {
  var NEW = 'https://playably.ai/cdn/shop/t/7/assets/favicon-purple-tri.png?v=14195588824266545541781189563';
  function fixFavicon() {
    var links = document.querySelectorAll("link[rel~='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']");
    if (links.length) {
      links.forEach(function (l) { if (l.href.indexOf('favicon-purple-tri') === -1) { l.href = NEW; } });
    } else {
      var l = document.createElement('link'); l.rel = 'icon'; l.type = 'image/png'; l.href = NEW; document.head.appendChild(l);
    }
  }
  fixFavicon();
})();



(function () {
  // Frozen-cache page: copy edits in templates never reach the cached HTML,
  // so dash cleanup has to happen client-side.
  function fixDashes() {
    var h1p = document.querySelector(".pa-gh-h1 p");
    if (h1p && /\u2014\s*faster/i.test(h1p.textContent)) {
      h1p.innerHTML = "Turn attention into revenue.<br><em>Faster.</em>";
    }
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (v.indexOf("\u2014") === -1) continue;
      var p = n.parentElement;
      if (p && /^(SCRIPT|STYLE)$/.test(p.tagName)) continue;
      if (/^\s*\d{2}\s*\u2014/.test(v)) continue;
      if (/^\s*\u2014/.test(v)) continue;
      n.nodeValue = v.replace(/\s*\u2014\s*/g, ", ");
    }
  }
  if (document.readyState !== "loading") { fixDashes(); } else { document.addEventListener("DOMContentLoaded", fixDashes); }
  setTimeout(fixDashes, 1600);
})();


  } catch(e) { console.error(e); }
})();
})();
